import React, { memo, useCallback, useContext } from 'react';

import { FilterContent } from './FilterContent/FilterContent';
import { SidebarBase } from '../SidebarBase/SidebarBase';
import { SidebarContext } from '../PageLayout/ContextProvider';

export const FilterSidebar = memo(({ navigationBarVisibility }) => {
    const {
        sidebarVisibility: { filterSidebarVisibility },
        handleToggleFilterSidebar,
    } = useContext(SidebarContext);

    const handleClose = useCallback(() => handleToggleFilterSidebar(false), []);

    return (
        <SidebarBase
            visibility={filterSidebarVisibility}
            handleClose={handleClose}
            anchor="right"
            navigationBarVisibility={navigationBarVisibility}
        >
            <FilterContent handleFiltersClose={handleClose} />
        </SidebarBase>
    );
});

FilterSidebar.displayName = 'FilterSidebar';
